import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable, tap } from 'rxjs';
import { environment as ENV } from '../../../environments/environment';
import { URL_MAP } from '../../shared/urlMap';
import {
  NotificacionCotizacionDTO,
  NotificacionCotizacionResumenDTO,
  NotificacionCotizacionesResponseDTO,
  ContadorNotificacionResponseDTO,
} from '../../models/notificaciones/notificacion-cotizacion.model';
import { NotificacionesSeguimientoService } from '../notificaciones-seguimiento.service';

@Injectable({
  providedIn: 'root',
})
export class NotificacionesService {

  private readonly baseUrl = `${ENV.HOST}${URL_MAP.API.NOTIFICACIONES_COTIZACION}`;

  private resumenSubject = new BehaviorSubject<NotificacionCotizacionResumenDTO | null>(null);
  public resumen$ = this.resumenSubject.asObservable();

  constructor(
    private http: HttpClient,
    private notificacionesSeguimientoService: NotificacionesSeguimientoService
  ) {}

  /** GET /{usuario} — carga inicial y refresco */
  getResumen(usuario: string): Observable<NotificacionCotizacionesResponseDTO> {
    return this.http
      .get<NotificacionCotizacionesResponseDTO>(`${this.baseUrl}/${usuario}`)
      .pipe(tap((resp) => this.actualizarEstado(resp)));
  }

  /** GET /{usuario}/contador — polling ligero cada 5 min */
  getContador(usuario: string): Observable<ContadorNotificacionResponseDTO> {
    return this.http.get<ContadorNotificacionResponseDTO>(
      `${this.baseUrl}/${usuario}/contador`
    );
  }

  /** PUT /{id}/leer/{usuario} — marcar como leída al hacer clic en VER */
  marcarLeida(
    id: number,
    usuario: string
  ): Observable<NotificacionCotizacionesResponseDTO> {
    return this.http
      .put<NotificacionCotizacionesResponseDTO>(
        `${this.baseUrl}/${id}/leer/${usuario}`,
        {}
      )
      .pipe(tap((resp) => this.actualizarEstado(resp)));
  }

  /** DELETE /{id}/{usuario} — soft-delete al hacer clic en ELIMINAR */
  eliminar(
    id: number,
    usuario: string
  ): Observable<NotificacionCotizacionesResponseDTO> {
    return this.http
      .delete<NotificacionCotizacionesResponseDTO>(
        `${this.baseUrl}/${id}/${usuario}`
      )
      .pipe(tap((resp) => this.actualizarEstado(resp)));
  }

  /** Devuelve el resumen actual del BehaviorSubject (sin llamada HTTP) */
  getResumenActual(): NotificacionCotizacionResumenDTO | null {
    return this.resumenSubject.value;
  }

  /** Actualiza el BehaviorSubject y sincroniza el contador del badge */
  private actualizarEstado(resp: NotificacionCotizacionesResponseDTO): void {
    if (resp?.status && resp.data) {
      this.resumenSubject.next(resp.data);
      this.notificacionesSeguimientoService.actualizarContador(
        resp.data.totalNoLeidas
      );
    }
  }
}
